import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const PatientInsurances = ({ insurances }) => (
  <div className="table-container">
    <h5>Patient Insurance</h5>
    <Table
      className="small-table"
      borderless
      border="0"
      cellSpacing="0"
      cellPadding="0"
    >
      <thead>
        <tr>
          <th>Provider</th>
          <th>Number</th>
          <th>Type</th>
          <th>Plan Name</th>
        </tr>
      </thead>
      <tbody>
        {insurances.map((insurance) => (
          <tr key={insurance.guid}>
            <td>{insurance.provider}</td>
            <td>{insurance.number}</td>
            <td>{insurance.type}</td>
            <td>{insurance.planName}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

PatientInsurances.propTypes = {
  insurances: PropTypes.arrayOf(PropTypes.shape()),
};

export default PatientInsurances;
